import { gql } from '@apollo/client';

export const getInsuredListQuery = gql`
  query GetInsuredList(
    $pagination: PaginationInput!
    $selectedBusinessPartners: [String]
    $Attribute: String!
    $Descending: Boolean!
    $FromCreatedOn: Date
    $ToCreatedOn: Date
    $KeywordSearch: String
  ) {
    Production {
      queries {
        getInsuredList(
          pagination: $pagination
          OrderBy: { Attribute: $Attribute, Descending: $Descending }
          FromCreatedOn: $FromCreatedOn
          ToCreatedOn: $ToCreatedOn
          selectedBusinessPartners: $selectedBusinessPartners
          KeywordSearch: $KeywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            production_Insured_Id
            production_Insured_InsuredCode
            production_Insured_FullName
            production_Insured_PersonID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Email
                  }
                }
              }
            }
            production_Insured_AssignedToBusinessPartnerID {
              id
              views {
                SalesforceManagement_all {
                  properties {
                    Code
                    PersonID {
                      id
                      views {
                        SalesforceManagement_all {
                          properties {
                            FullName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            production_Insured_LinkedBusinessPartnerIDs {
              views {
                SalesforceManagement_all {
                  properties {
                    Id
                    Code
                    PersonID {
                      id
                      views {
                        SalesforceManagement_all {
                          properties {
                            FullName
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            production_Insured_PhoneDetails {
              PhoneType
              PhoneNumber
            }
            production_Insured_createdOn
            production_Insured_modifiedOn
          }
        }
      }
    }
  }
`;

export const filterQuery = gql`
  query getAssignedBusinessPartnerList {
    Production {
      queries {
        getAssignedBPListWithoutPagination {
          salesforceManagement_AssignedBP_Id
          salesforceManagement_AssignedBP_BusinessPartnerID {
            id
            views {
              SalesforceManagement_all {
                properties {
                  Code
                  PersonID {
                    id
                    views {
                      SalesforceManagement_all {
                        properties {
                          FullName
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
